import { Apis } from '../../app.constants.js';
import APIService from '../../APIService.js';
import { useRecoilValue } from 'recoil';
import { userInformationAtom } from '../../_states/auth.js';

type ManagementActionsType = {
  getRoleList: (data) => Promise<any>;
  postRole: (data) => Promise<any>;
  updateRole: (data) => Promise<any>;
  deleteRole: (id) => Promise<any>;
  getProfileList: (data) => Promise<any>;
  createProfile: (data) => Promise<any>;
  deleteProfile: (id) => Promise<any>;
  updateProfile: (data, id) => Promise<any>;
  getContentTypes: () => Promise<any>;
  createObjectLevelPermission: (data) => Promise<any>;
  updateObjectLevelPermission: (data, id: any) => Promise<any>;
  updateGeneralUserLevelPermission: (data, id: any) => Promise<any>;
  createGeneralUserLevelPermission: (data: any) => Promise<any>;
  getUserList: (data) => Promise<any>;
  createUser: (data) => Promise<any>;
  updateUser: (data) => Promise<any>;
  deleteUser: (id) => Promise<any>;
  changeUserPassword: (data) => Promise<any>;
  cloneProfileApi: (cloneData) => Promise<any>;
  getOrganisationMapping: (data) => Promise<any>;
  getAllBusinessTypeSubTypes: () => Promise<any>;
  createOrganisation: (data) => Promise<any>;
  updateOrganisation: (data) => Promise<any>;
  deleteOrganisation: (organisation_id) => Promise<any>;
  postOrganisationMap: (data) => Promise<any>;
  generateApiKey: () => Promise<any>;
  fetchApiKey: () => Promise<any>;
  updateApiKey: (isActive: boolean) => Promise<any>;
  assignRole: (data) => Promise<any>;
  fetchEntityTemplateForm: () => Promise<any>;
};

const ManagementActions = (): ManagementActionsType => {
  const loggedInUser = useRecoilValue(userInformationAtom);
  const getRoleList = async (data?: any): Promise<any> => {
    try {
      // let organisationId = "";
      // if (data?.organisationId)
      //   organisationId = data?.organisationId;
      // else
      //   organisationId = loggedInUser?.profile?.organisation?.organisation_id;

      // if (!organisationId) {
      //   throw new Error("Organisation ID is not available.");
      // }
      let url = `${Apis.getRoleList}?search=${data?.search || ''}&next_page=${data?.page || 1}&limit=${data?.limit || 20}`;
      if (data?.organisation_id) {
        url += `&organisation_id=${data?.organisation_id || ''}`;
      }
      const res = await APIService.get(url);
      return res;
    } catch (error) {
      console.error('Error fetching role list:', error);
      throw error; // Re-throw the error for further handling
    }
  };
  const postRole = async (data?: any): Promise<any> => {
    try {
      const url = `${Apis.getRoleList}`;
      const res = await APIService.post(url, data);
      return res;
    } catch (error) {
      console.error('Error fetching role list:', error);
      throw error;
    }
  };
  const updateRole = async (data?: any): Promise<any> => {
    try {
      const url = `${Apis.getRoleList}?id=${data?.id}`;
      const res = await APIService.put(url, data);
      return res;
    } catch (error) {
      console.error('Error fetching role list:', error);
      throw error;
    }
  };

  const deleteRole = async (id: any): Promise<any> => {
    try {
      const url = `${Apis.getRoleList}?id=${id}`;
      const res = await APIService.remove(url);
      return res;
    } catch (error) {
      console.error('Error fetching role list:', error);
      throw error;
    }
  };

  const getProfileList = async (data?: any): Promise<any> => {
    try {
      let url = `${Apis.getProfileList}?next_page=${data?.page || 1}&search=${data?.search || ''}&limit=${data?.limit || 20}`;
      if (data?.organisation_id) {
        url += `&organisation_id=${data?.organisation_id || ''}`;
      }
      const res = await APIService.get(url);
      return res;
    } catch (error) {
      console.error('Error fetching role list:', error);
      throw error;
    }
  };

  const createProfile = async (data?: any): Promise<any> => {
    try {
      const url = `${Apis.createProfile}`;
      const res = await APIService.post(url, data);
      return res;
    } catch (error) {
      console.error('Error fetching role list:', error);
      throw error;
    }
  };

  const updateProfile = async (data?: any, id?: any): Promise<any> => {
    try {
      const url = `${Apis.createProfile}${id}/`;
      const res = await APIService.put(url, data);
      return res;
    } catch (error) {
      console.error('Error fetching role list:', error);
      throw error;
    }
  };

  const deleteProfile = async (id): Promise<any> => {
    try {
      const url = `${Apis.createProfile}${id}/`;
      const res = await APIService.remove(url);
      return res;
    } catch (error) {
      console.error('Error fetching role list:', error);
      throw error;
    }
  };

  const getContentTypes = async () => {
    try {
      const res = await APIService.get(Apis.getContentTypes);
      return res;
    } catch (error) {
      console.error('Error fetching role list:', error);
      throw error;
    }
  };

  const createObjectLevelPermission = async (data) => {
    try {
      const url = `${Apis.objectLevelPermission}`;
      const res = await APIService.post(url, data);
      return res;
    } catch (error) {
      console.error('Error:', error);
      throw error;
    }
  };

  const updateObjectLevelPermission = async (data, id) => {
    try {
      const url = `${Apis.objectLevelPermission}${id}/`;
      const res = await APIService.put(url, data);
      return res;
    } catch (error) {
      console.error('Error:', error);
      throw error;
    }
  };

  const updateGeneralUserLevelPermission = async (data, id) => {
    try {
      const url = `${Apis.generalUserPermission}${id}/`;
      const res = await APIService.put(url, data);
      return res;
    } catch (error) {
      console.error('Error:', error);
      throw error;
    }
  };

  const createGeneralUserLevelPermission = async (data) => {
    try {
      const url = `${Apis.generalUserPermission}`;
      const res = await APIService.post(url, data);
      return res;
    } catch (error) {
      console.error('Error:', error);
      throw error;
    }
  };
  const getUserList = async (data: any): Promise<any> => {
    // const organisationId = loggedInUser?.profile?.organisation?.organisation_id;
    // if (!organisationId) {
    //   throw new Error("Organisation ID is not available.");
    // }

    try {
      let url = `${Apis.getUsersByOrganisation}?next_page=${data?.page || 1}&search=${data?.search || ''}&limit=${data?.limit}`;
      if (data?.organisation_id) {
        url += `&organisation_id=${data?.organisation_id || ''}`;
      }
      let res = await APIService.get(url);
      return res;
    } catch (error) {
      throw error;
    }
  };

  const createUser = async (data?: any): Promise<any> => {
    try {
      const url = `${Apis.getUsersByOrganisation}`;
      const res = await APIService.post(url, data);
      return res;
    } catch (error) {
      console.error('Error fetching role list:', error);
      throw error;
    }
  };
  const updateUser = async (data?: any): Promise<any> => {
    try {
      const url = `${Apis.getUsersByOrganisation}${data?.id}/`;
      const res = await APIService.put(url, data);
      return res;
    } catch (error) {
      console.error('Error fetching role list:', error);
      throw error;
    }
  };

  const deleteUser = async (id: any): Promise<any> => {
    try {
      const url = `${Apis.getUsersByOrganisation}${id}/`;
      const res = await APIService.remove(url);
      return res;
    } catch (error) {
      console.error('Error fetching role list:', error);
      throw error;
    }
  };

  const changeUserPassword = async (data: any): Promise<any> => {
    try {
      const url = `${Apis.getUsersByOrganisation}${data.id}/change_password/`;
      const res = await APIService.post(url, data);
      return res;
    } catch (error) {
      console.error('Error fetching role list:', error);
      throw error;
    }
  };

  const cloneProfileApi = async (cloneData: {
    clone_from_profile_id: number;
    new_organisation_id: string;
    new_name: string;
  }) => {
    try {
      const response = await APIService.post('/v0/ui/website/clone-profile/', cloneData);
      return response;
    } catch (error) {
      console.error('Error cloning profile:', error);
      throw error;
    }
  };

  const getOrganisationMapping = async (data?: {
    page?: number;
    search?: string;
    organisation_id?: string;
    limit?: any;
  }): Promise<any> => {
    try {
      const baseUrl = '/v0/ui/website/organisation-map/';
      // const sourceOrganisationId = data?.sourceOrganisationId || "MAC1421"; // Default if not provided
      const page = data?.page || 1;
      const search = data?.search || '';
      let url = `${baseUrl}?next_page=${page}&search=${encodeURIComponent(search)}&limit=${data?.limit}`;
      if (data?.organisation_id) {
        url += `&source_organisation_id=${data?.organisation_id}`;
      }

      const res = await APIService.get(url);
      return res;
    } catch (error) {
      console.error('Error fetching organisation mapping:', error);
      throw error;
    }
  };

  // } /v0/user/263/change_password/

  const getAllBusinessTypeSubTypes = async () => {
    try {
      let res = await APIService.get(`${Apis.getAllSectors}`);
      return res;
    } catch (error) {
      throw error;
    }
  };
  const createOrganisation = async (data) => {
    try {
      const response = await APIService.post(Apis.Get_Organisation_List, data);
      return response;
    } catch (error) {
      console.error('Error Created organisation:', error);
      throw error;
    }
  };
  const updateOrganisation = async (data) => {
    try {
      const response = await APIService.put(
        `${Apis.Get_Organisation_List}${data?.organisation_id}/`,
        data
      );
      return response;
    } catch (error) {
      console.error('Error updating organisation:', error);
      throw error;
    }
  };
  const deleteOrganisation = async (organisation_id: any): Promise<any> => {
    try {
      const res = await APIService.remove(`${Apis.Get_Organisation_List}${organisation_id}/`);
      return res;
    } catch (error) {
      console.error('Error fetching role list:', error);
      throw error;
    }
  };

  const postOrganisationMap = async (data?: any): Promise<any> => {
    try {
      const url = `/v0/ui/website/organisation-map/`;
      const res = await APIService.post(url, data);
      return res;
    } catch (error) {
      throw error;
    }
  };

  const generateApiKey = async (): Promise<any> => {
    try {
      const res = await APIService.post(Apis.generateApiKey);
      return res;
    } catch (error) {
      throw error;
    }
  };
  const updateApiKey = async (isActive: boolean): Promise<any> => {
    try {
      let url = `${Apis.generateApiKey}`;
      if (isActive !== undefined) {
        url += `?is_active=${isActive}`;
      }
      const res = await APIService.put(url);
      return res;
    } catch (error) {
      throw error;
    }
  };
  const fetchApiKey = async (): Promise<any> => {
    try {
      const res = await APIService.get(Apis.generateApiKey);
      return res;
    } catch (error) {
      throw error;
    }
  };

  const assignRole = async (data: any): Promise<any> => {
    try {
      const url = `/v0/ui/website/role-hierarchy/`;
      const res = await APIService.post(url, data);
      return res;
    } catch (error) {
      throw error;
    }
  };

  const unlockUser = async (username: string): Promise<any> => {
    try {
      const url = `${Apis.unlockUser}?username=${username}`;
      const response = await APIService.post(url);
      return response;
    } catch (error) {
      console.error('Error unlocking user:', error);
      return error?.response || { status: 500, data: { message: 'Failed to unlock user' } };
    }
  };

  const fetchEntityTemplateForm = async (filters: any = {}) => {
    try {
      const res = await APIService.get(
        `${Apis.entityManagement}template-form/list`
      );
      return res;
    } catch (error) {
      throw error;
    }
  };

  return {
    getRoleList,
    deleteRole,
    postRole,
    updateRole,
    getProfileList,
    createProfile,
    updateProfile,
    deleteProfile,
    getContentTypes,
    createObjectLevelPermission,
    updateObjectLevelPermission,
    updateGeneralUserLevelPermission,
    createGeneralUserLevelPermission,
    getUserList,
    createUser,
    updateUser,
    deleteUser,
    changeUserPassword,
    cloneProfileApi,
    getOrganisationMapping,
    getAllBusinessTypeSubTypes,
    createOrganisation,
    updateOrganisation,
    deleteOrganisation,
    postOrganisationMap,
    generateApiKey,
    fetchApiKey,
    updateApiKey,
    assignRole,
    unlockUser,
    fetchEntityTemplateForm,
  };
};

export { ManagementActions };
